/** Orbit controls, tuned for a deck you look down at rather than a landscape. */

import * as THREE from 'three';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';

/** Never let the camera go under the deck. */
export const MAX_POLAR = 1.42;

export function createControls(
  camera: THREE.PerspectiveCamera,
  canvas: HTMLCanvasElement,
): OrbitControls {
  const controls = new OrbitControls(camera, canvas);
  controls.enableDamping = true;
  controls.dampingFactor = 0.075;
  controls.rotateSpeed = 0.72;
  controls.zoomSpeed = 0.85;
  controls.panSpeed = 0.6;
  controls.enablePan = true;
  controls.screenSpacePanning = false;
  controls.minPolarAngle = 0;
  controls.maxPolarAngle = MAX_POLAR;
  controls.minDistance = 26;
  controls.maxDistance = 240;
  controls.target.set(0, 4, 0);
  controls.touches = { ONE: THREE.TOUCH.ROTATE, TWO: THREE.TOUCH.DOLLY_PAN };
  controls.mouseButtons = {
    LEFT: THREE.MOUSE.ROTATE,
    MIDDLE: THREE.MOUSE.DOLLY,
    RIGHT: THREE.MOUSE.PAN,
  };
  return controls;
}
